import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
  useGetList,
  NumberInput,
} from 'react-admin';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Dashboard as DashboardIcon } from '@mui/icons-material';
import RolePermissionManager from '../../components/RolePermissionManager';
import { useRolePermissionTransform } from '../../hooks/useRolePermissionTransform';

const DashboardGroupsCreate = () => {
  // Hook para transformación de roles
  const { transformRoles } = useRolePermissionTransform();
  
  // Obtener lista de plantas
  const { data: plants, isLoading: plantsLoading } = useGetList('plants', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'plantName', order: 'ASC' },
  });

  const plantChoices = plants
    ? plants.map((plant: any) => ({
        id: plant.id,
        name: plant.plantName,
      }))
    : [];

  return (
    <Create title='Crear Grupo de Dashboard' redirect='list' transform={transformRoles}>
      <Card sx={{ maxWidth: 800, margin: 'auto' }}>
        <CardContent>
          <Box display='flex' alignItems='center' mb={3}>
            <DashboardIcon
              sx={{ mr: 2, fontSize: 32, color: 'primary.main' }}
            />
            <Typography variant='h5' component='h1'>
              Nuevo Grupo de Dashboard
            </Typography>
          </Box>

          <SimpleForm>
            <Box
              sx={{
                display: 'grid',
                gap: 2,
                width: '100%',
              }}
            >
              <TextInput
                source='groupName'
                label='Nombre del Grupo'
                validate={[required()]}
                fullWidth
                helperText='Nombre descriptivo para el grupo de dashboards'
              />
            </Box>{' '}
            <SelectInput
              source='plantId'
              label='Planta Asociada'
              choices={plantChoices}
              validate={[required()]}
              isLoading={plantsLoading}
              fullWidth
              helperText='Selecciona la planta a la que pertenece este grupo'
            />
            
            <RolePermissionManager
              title="Permisos del Grupo de Dashboards"
              subtitle="Configurar roles y permisos para este grupo"
              helperText="Los permisos aplicarán a todos los dashboards dentro de este grupo."
              showCard={false}
            />
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default DashboardGroupsCreate;
